// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatapointFilterItemFromJSON, DatapointFilterItemToJSON, } from './';
export function DatapointsExcelRequestSpecifics1FromJSON(json) {
    return {
        'filters': json['filters'].map(DatapointFilterItemFromJSON),
    };
}
export function DatapointsExcelRequestSpecifics1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'filters': value.filters.map(DatapointFilterItemToJSON),
    };
}
